<template>
  <div>
    <b-container class="contentcontainer">
      <b-row class="contentcontainer__head">
        <b-col>
          <h2>{{ $t('user.accountsection') }}</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <table class="table table--overview">
            <tr>
              <td>
                {{ $t('user.acompany') }}
              </td>
              <td>
                {{ userDetail.data.a_company }}
              </td>
            </tr>

            <tr>
              <td>
                {{ $t('user.afirstname') }}
              </td>
              <td>
                {{ userDetail.data.a_firstname }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('user.alastname') }}
              </td>
              <td>
                {{ userDetail.data.a_lastname }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('user.street') }}
              </td>
              <td>
                {{ userDetail.data.a_street }} {{ userDetail.data.a_housenumber }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('user.city') }}
              </td>
              <td>
                {{ userDetail.data.a_zip }} {{ userDetail.data.a_city }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('user.homepage') }}
              </td>
              <td>
                {{ userDetail.data.a_homepage }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('user.telephone') }}
              </td>
              <td>
                {{ userDetail.data.a_telephone }}
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'UserDetailAccount',

  mixins: [mixins],

  components: {

  },

  computed: {
    ...mapState('user', [
      'userDetail'
    ]),

    vatidVaildCheckDate () {
      return this.transformTime(this.userDetail.data.a_vatid_valid_check_date, this.userDetail.data.timezone)
    }

  },

  methods: {
    ...mapMutations('user', [
      'closeUserDetailPage'
    ]),

    close () {
      this.closeUserDetailPage()
    },

    localRemove () {
      this.closeUserDetailPage()
      this.setUserDetailId(0)
      this.$router.push({
        name: 'userDestroy',
        params: {
          id: this.userDetail.id
        }
      })
    }

  }
}
</script>
